import { type FC } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { ProductsFilter } from "./ProductsFilter";
import { ProductsList } from "./ProductsList";
import { CreateProductDialog } from "./CreateProductDialog";
import { EditProductDialog } from "./EditProductDialog";

export const Products: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = searchParams.get("tab");
  const editId = searchParams.get("id");

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <ProductsFilter onCreate={handleCreate} />
        <ProductsList onEditProduct={handleEdit} />
      </Stack>

      <CreateProductDialog
        open={tab === "create"}
        onClose={handleClose}
        onCompleted={handleClose}
      />
      <EditProductDialog
        // ?tab= несёт активную вкладку карточки: edit или records2257
        // (записи 2257, спека §4).
        open={(tab === "edit" || tab === "records2257") && Boolean(editId)}
        productId={editId}
        tab={tab ?? "edit"}
        onClose={handleClose}
        onCompleted={handleClose}
      />
    </FilterProvider>
  );
};
